import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) => (n == null ? "—" : `$${Number(n).toFixed(0)}`);

export function payLabel(shift) {
  if (!shift) return "—";
  if (shift.pay_type === "negotiable") return "Negotiable";
  if (shift.pay_type === "range" && shift.pay_rate_max)
    return `${money(shift.pay_rate)}–${money(shift.pay_rate_max)}/hr`;
  return `${money(shift.pay_rate)}/hr`;
}

export function fmtTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const hh = h % 12 === 0 ? 12 : h % 12;
  return `${hh}:${String(m).padStart(2, "0")} ${ampm}`;
}

export function fmtDate(d, opts = { month: "short", day: "numeric" }) {
  if (!d) return "";
  const dt = new Date(`${d}T12:00:00`);
  return dt.toLocaleDateString("en-US", opts);
}

export function fmtDateLong(d) {
  return fmtDate(d, { weekday: "short", month: "short", day: "numeric", year: "numeric" });
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function addDaysISO(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}
